// components
import Modal from "../Modal";

const ImageModal = (props) => {
  // props
  const { imageSource, imageAlt, close } = props;

  return (
    <Modal close={close} classNames="w-11/12 sm:w-3/4">
      <img src={imageSource} alt={imageAlt} className="w-full" />
    </Modal>
  );
};

export default ImageModal;
